import React from "react"
import "../Sass/footer.css"
import SocialIcon from "./SocialsIcon"

const Footer = () => {
  return (
    <section>
      <div className="footer pb-0">
        <div className="container">
          <div className="row text-center">
            <div className="col-12">
              <h4 className="footer__text">
                For Any Query You Can Contact Me On
              </h4>
            </div>
            <SocialIcon />
          </div>
        </div>
      </div>
    </section>
  )
}

export default Footer
